import React from "react"

interface Props extends React.ComponentPropsWithoutRef<"svg"> {
    width?: number | string
    height?: number | string
    color?: string
    className?: string
    style?: React.CSSProperties
}

export function ColonSeparatorIcon({
    width = 5,
    height = 18,
    color = "currentColor",
    className = "",
    style,
    ...others
}: Props) {
    return (
        <svg
            aria-hidden="true"
            role="img"
            focusable="false"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 5 18"
            color={color}
            style={{ width, height, display: "block", ...style }}
            className={className}
            {...others}
        >
            <path
                fill="currentColor"
                d="M0 15.3906C0 14.8073 0.197917 14.3177 0.59375 13.9219C0.989583 13.5156 1.52604 13.3125 2.20312 13.3125C2.89062 13.3125 3.42708 13.5156 3.8125 13.9219C4.20833 14.3177 4.40625 14.8073 4.40625 15.3906C4.40625 15.974 4.20833 16.4635 3.8125 16.8594C3.42708 17.2552 2.89062 17.4531 2.20312 17.4531C1.52604 17.4531 0.989583 17.2552 0.59375 16.8594C0.197917 16.4635 0 15.974 0 15.3906ZM0.015625 2.07812C0.015625 1.49479 0.213542 1.00521 0.609375 0.609375C1.00521 0.203125 1.54167 0 2.21875 0C2.90625 0 3.44271 0.203125 3.82812 0.609375C4.22396 1.00521 4.42188 1.49479 4.42188 2.07812C4.42188 2.66146 4.22396 3.15104 3.82812 3.54688C3.44271 3.94271 2.90625 4.14062 2.21875 4.14062C1.54167 4.14062 1.00521 3.94271 0.609375 3.54688C0.213542 3.15104 0.015625 2.66146 0.015625 2.07812Z"
            />
        </svg>
    )
}
